"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppEventsAccessor = exports.AppEventSubscriptionAccessor = exports.AppEventSubscriptionsAccessor = exports.AppEventTypeAccessor = exports.AppEventTypesAccessor = void 0;
const accessors_1 = require("../accessors");
class AppEventTypesAccessor extends accessors_1.ElementListAccessor {
    constructor(client) {
        super(client, 'app-event-types');
    }
}
exports.AppEventTypesAccessor = AppEventTypesAccessor;
class AppEventTypeAccessor extends accessors_1.ElementAccessor {
    constructor(client, idOrKey) {
        super({
            client,
            path: 'app-event-types',
            idOrKey,
        });
    }
}
exports.AppEventTypeAccessor = AppEventTypeAccessor;
class AppEventSubscriptionsAccessor extends accessors_1.ElementInstanceListAccessor {
    constructor(client) {
        super(client, 'app-event-subscriptions');
    }
}
exports.AppEventSubscriptionsAccessor = AppEventSubscriptionsAccessor;
class AppEventSubscriptionAccessor extends accessors_1.ElementInstanceAccessor {
    constructor(client, selector) {
        super({
            client,
            instancePath: 'app-event-subscription',
            selector,
        });
    }
    async subscribe() {
        const id = await this.getId();
        return this.options.client.post(`app-event-subscriptions/${id}/subscribe`);
    }
}
exports.AppEventSubscriptionAccessor = AppEventSubscriptionAccessor;
class AppEventsAccessor extends accessors_1.ElementInstanceListAccessor {
    constructor(client) {
        super(client, 'app-events');
    }
}
exports.AppEventsAccessor = AppEventsAccessor;
//# sourceMappingURL=accessors.js.map